import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const deliveryMethodImporterSelectors = importerSelectors(
  'deliveryMethod.importer',
)

export default deliveryMethodImporterSelectors
